import { ScopeOption } from '../types';

/**
 * Варианты скоупов для модуля «Пользователи» (users.*)
 * У изменяющих прав нет «Моя роль и ниже»: равные ранги защищены всегда (AGENTS §5.3), и вариант совпадал бы
 * с «Только ниже моей роли». Старые значения в БД переводит migrations/migrate_users_scope_below_my_role.js
 */
export const usersScopes: Record<string, ScopeOption[]> = {
  // Список пользователей
  'users.view': [
    {
      value: 'all',
      label: 'Все пользователи',
      description: 'Доступ ко всем сотрудникам и аптекам всей сети',
      badgeColor: '#10b981'
    },
    {
      value: 'my_role_and_below',
      label: 'Моя роль и ниже',
      description: 'Пользователи своего ранга и ниже',
      badgeColor: '#059669'
    },
    {
      value: 'below_my_role',
      label: 'Только ниже моей роли',
      description: 'Пользователи с рангом строго ниже текущего оператора',
      badgeColor: '#3b82f6'
    },
    {
      value: 'created_by_me',
      label: 'Только созданные мной',
      description: 'Пользователи, зарегистрированные данным оператором',
      badgeColor: '#8b5cf6'
    },
    {
      value: 'assigned_pharmacies',
      label: 'Назначенные аптеки',
      description: 'Только пользователи из курируемых аптек (поле myPharmacy)',
      badgeColor: '#f59e0b'
    },
    {
      value: 'own_region',
      label: 'Только свой регион',
      description: 'Пользователи того же города/региона (поле cityId)',
      badgeColor: '#06b6d4'
    }
  ],

  // Смена пароля
  'users.edit_password': [
    {
      value: 'all_in_list',
      label: 'Все доступные в списке',
      description: 'Смена пароля любым видимым пользователям (кроме равных и старших)',
      badgeColor: '#10b981'
    },
    {
      value: 'below_my_role',
      label: 'Только ниже моей роли',
      description: 'Смена пароля только строго нижестоящим сотрудникам',
      badgeColor: '#3b82f6'
    },
    {
      value: 'created_by_me',
      label: 'Только созданные мной',
      description: 'Смена пароля только своим созданным сотрудникам',
      badgeColor: '#8b5cf6'
    },
    {
      value: 'none',
      label: 'Запрещено (никому)',
      description: 'Оператор не может менять чужие пароли',
      badgeColor: '#ef4444'
    }
  ],

  // Сброс биометрии (Face ID)
  'users.reset_biometrics': [
    {
      value: 'all_in_list',
      label: 'Все доступные в списке',
      description: 'Сброс биометрии любым видимым сотрудникам (кроме равных и старших)',
      badgeColor: '#10b981'
    },
    {
      value: 'below_my_role',
      label: 'Только ниже моей роли',
      description: 'Сброс биометрии только строго нижестоящим сотрудникам',
      badgeColor: '#3b82f6'
    },
    {
      value: 'created_by_me',
      label: 'Только созданные мной',
      description: 'Сброс биометрии только созданным сотрудникам',
      badgeColor: '#8b5cf6'
    },
    {
      value: 'none',
      label: 'Запрещено',
      description: 'Сброс биометрии сотрудникам отключен',
      badgeColor: '#ef4444'
    }
  ],

  // Управление статусами (активация / касса / отчеты)
  'users.toggle_status': [
    {
      value: 'all_in_list',
      label: 'Все доступные в списке',
      description: 'Переключение блокировки и кассы для всех видимых пользователей (кроме равных и старших)',
      badgeColor: '#10b981'
    },
    {
      value: 'below_my_role',
      label: 'Только ниже моей роли',
      description: 'Только для пользователей строго ниже рангом',
      badgeColor: '#3b82f6'
    },
    {
      value: 'created_by_me',
      label: 'Только созданные мной',
      description: 'Только для созданных учетных записей',
      badgeColor: '#8b5cf6'
    },
    {
      value: 'none',
      label: 'Запрещено',
      description: 'Управление блокировками отключено',
      badgeColor: '#ef4444'
    }
  ],

  // Вход под пользователем (Impersonation)
  'users.impersonate': [
    {
      value: 'all_in_list',
      label: 'Все доступные в списке',
      description: 'Вход под любым видимым пользователем (кроме равных и старших)',
      badgeColor: '#10b981'
    },
    {
      value: 'created_by_me',
      label: 'Только созданные мной',
      description: 'Вход только под своими созданными сотрудниками',
      badgeColor: '#8b5cf6'
    },
    {
      value: 'none',
      label: 'Запрещено',
      description: 'Функция входа под пользователем скрыта',
      badgeColor: '#ef4444'
    }
  ],

  // Редактирование профилей
  'users.edit_profile': [
    {
      value: 'below_my_role',
      label: 'Только ниже моей роли',
      description: 'Профили пользователей строго младшего ранга',
      badgeColor: '#3b82f6'
    },
    {
      value: 'created_by_me',
      label: 'Только созданные мной',
      description: 'Только для своих созданных записей',
      badgeColor: '#8b5cf6'
    },
    {
      value: 'all',
      label: 'Все пользователи',
      description: 'Редактирование профилей любых пользователей (кроме равных и старших)',
      badgeColor: '#059669'
    },
    {
      value: 'none',
      label: 'Запрещено',
      description: 'Редактирование чужих профилей отключено',
      badgeColor: '#ef4444'
    }
  ]
};
